import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-comman-add-edit',
  templateUrl: './comman-add-edit.component.html',
  styleUrls: ['./comman-add-edit.component.scss']
})
export class CommanAddEditComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public CurrentDetail:any=[];
  public currentUrl:any=this.router.url;

  commanData = new FormGroup({
    name:new FormControl('',Validators.compose([
      Validators.required ])),
    color:new FormControl(''),
    type:new FormControl('')
  })
  
   get f() { return this.commanData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {
    if(this.currentUrl == '/edit-ability' ||  this.currentUrl == '/edit-primary-category' || this.currentUrl == '/edit-content-piller' || this.currentUrl == '/edit-primary-piller'
    ||this.currentUrl == '/edit-medical' ||  this.currentUrl == '/edit-location' || this.currentUrl == '/edit-suitability'
    ||this.currentUrl == '/edit-diet' ||  this.currentUrl == '/edit-subcategory' || this.currentUrl == '/edit-cookingtime' 
    || this.currentUrl == '/edit-race' || this.currentUrl == '/edit-level' || this.currentUrl == '/edit-demographic' || this.currentUrl == '/edit-reason'){ 
      this.CurrentDetail= JSON.parse(localStorage.getItem('gra_EditData')||'{}')
    }
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail:any = this.commanData;
      var url:any=''; var detail:any={};  
      if(this.currentUrl=='/add-content-piller' || this.currentUrl == '/edit-content-piller'|| this.currentUrl=='/add-primary-piller' || this.currentUrl == '/edit-primary-piller'){
        this.commanData.controls["color"].setValidators([Validators.required]);
        this.commanData.controls["color"].updateValueAndValidity();
        if( this.currentUrl == '/edit-content-piller' ||  this.currentUrl == '/edit-primary-piller'){
          this.commanData.controls["color"].setValue(this.CurrentDetail.color);
        }
      }   
      if(this.currentUrl=='/add-reason' || this.currentUrl == '/edit-reason'){
        this.commanData.controls["type"].setValidators([Validators.required]);
        this.commanData.controls["type"].updateValueAndValidity();
      }    
      if(userdetail.valid){
        this.loading=true;
        detail={'name':userdetail.value.name};  
        if(this.currentUrl == '/edit-ability'){
          url='/abilities-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-ability'){
          url='/abilities-create';
        }  
 
        else if(this.currentUrl == '/edit-primary-category'){
          url='/primary-categories-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-primary-category'){
          url='/primary-categories-create';
        } 
        else if(this.currentUrl == '/edit-content-piller'){
          url='/content-pillars-update';
          detail.id =this.CurrentDetail._id;
          detail.color =userdetail.value.color;
        } 
        else if(this.currentUrl == '/add-content-piller'){
          url='/content-pillars-create';
          detail.color =userdetail.value.color;
        } 
        else if(this.currentUrl == '/edit-primary-piller'){
          url='/primary-pillar-update';
          detail.id =this.CurrentDetail._id;
          detail.color =userdetail.value.color;
        } 
        else if(this.currentUrl == '/add-primary-piller'){
          url='/primary-pillar-create';
          detail.color =userdetail.value.color;
        }
        else if(this.currentUrl == '/edit-race'){
          url='/race-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-race'){
          url='/race-create';
        } 
        else if(this.currentUrl == '/edit-level'){
          url='/level-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-level'){
          url='/level-create';
        }   
        
        else if(this.currentUrl == '/edit-medical'){
          url='/medical-conditions-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-medical'){
          url='/medical-conditions-create';
        } 
        else if(this.currentUrl == '/edit-location'){
          url='/area-location-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-location'){
          url='/area-location-create';
        } 
        else if(this.currentUrl == '/edit-suitability'){
          url='/suitability-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-suitability'){
          url='/suitability-create';
        }  
        
        else if(this.currentUrl == '/edit-diet'){
          url='/update-diet';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-diet'){
          url='/diet-create';
        } 

        else if(this.currentUrl == '/edit-subcategory'){
          url='/update-subcategory';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-subcategory'){
          url='/create-subcategory';
        } 

        else if(this.currentUrl == '/edit-cookingtime'){
          url='/cooking-times-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-cookingtime'){
          url='/cooking-times-create';
        } 

        else if(this.currentUrl == '/edit-demographic'){
          url='/demographic-update';
          detail.id =this.CurrentDetail._id
        } 
        else if(this.currentUrl == '/add-demographic'){
          url='/cooking-times-create';
        }

        else if(this.currentUrl == '/edit-reason'){
          url='/reason-update/';
          detail.id =this.CurrentDetail._id;
          detail.reason_type =userdetail.value.type;
        }
        else if(this.currentUrl == '/add-reason'){
          url='/reason-create';
          detail.reason_type =userdetail.value.type;
        }
        if(this.currentUrl == '/edit-ability' ||  this.currentUrl == '/edit-primary-category' || this.currentUrl == '/edit-content-piller' || this.currentUrl == '/edit-primary-piller'
        || this.currentUrl == '/edit-medical' ||  this.currentUrl == '/edit-location' || this.currentUrl == '/edit-suitability'
        ||this.currentUrl == '/edit-diet' ||  this.currentUrl == '/edit-subcategory' || this.currentUrl == '/edit-cookingtime'
        || this.currentUrl == '/edit-race' || this.currentUrl == '/edit-level' || this.currentUrl == '/edit-demographic' || this.currentUrl == '/edit-reason' ){ 
        this.service.updateApi(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.commanData.reset();
          this.submitted = false;  
          this.loading=false;  
          this.service.back();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });

    } else {
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.commanData.reset();
          this.submitted = false;  
          this.loading=false;  
          this.service.back();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });
    }
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
  
  getUploadFileDetail(event: any) {
    //this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.service.dangerAlert("Only images are supported.");
        return;
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
      };
    }
  }
  
  changeImage() {
    $("#file1").trigger("click");
  }
}
